import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from '~/components/Steps/Photos/PhotoLayout';

export function BackDriversideAngle() {
  return <PhotoLayout {...photoLayoutConfig['backDriversideAngle']} />;
}
